import { extendTheme, ThemeConfig } from "@chakra-ui/react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { dark } from "./colors";
import Alert from "./components/alert";
import primary from "./colors/primary";
import Button from "./components/button";
import Table from "./components/table";
import Checkbox from "./components/checkbox";
import bgray from "./colors/bgray";
import semanticTokens from "./semanticTokens";

export const colors = {
  primary,
  bgray,
  brand: {
    // primary: "#7630EC",
    // primaryLight: "#F7F1FF",
    // primaryText: "#7630EC",
    background: "#1D1D1D",
    backgroundLight: "#2B2B2B",
    textBg: "#1D1D1D",
    textColor: "#fff",
    textLight: "#000",
    disabledText: "#8C8C8C",
    textInactive: "#686868",
    separator: "#F0F0F5",
    errorColor: "#FF002E",
    social: {
      text: "#686868",
      icon: "#B5B5B5",
    },
    sideNavFooter: {
      text: "#686868",
      hover: "#FFF",
    },
    defiPreview: {
      text: "#6EC163",
      bg: "#3D4732",
    },
    alert: {
      infoColor: "#fff",
      infoBgColor: "#3182CE80",
      infoIconColor: "#EBF8FF",
      errorColor: "#fff",
      errorBgColor: "#C5303080",
      errorIconColor: "#fff",
      warningColor: "#fff",
      warningBgColor: "#ECC94B99",
      warningIconColor: "#fff",
    },
    auditedBy: {
      boderColor: "#424242",
    },
    banner: {
      text: "#FFF",
      background: "#3182CE80",
      dangerBackground: "#E53E3E",
    },
    modalOverlay: "#000000CC",
    ...dark.brand,
  },
};

export const styles = {
  global: () => ({
    body: {
      bg: "brand.background",
      color: "brand.textColor",
    },
  }),
};

const config: ThemeConfig = {
  initialColorMode: "dark",
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  fonts: {
    body: `"IBM Plex Sans", Montserrat, -apple-system, BlinkMacSystemFont, Roboto, sans-serif;`,
    heading: `"IBM Plex Sans", Montserrat, -apple-system, BlinkMacSystemFont, Roboto, sans-serif;`,
    mono: `"IBM Plex Sans", Montserrat, -apple-system, BlinkMacSystemFont, Roboto, sans-serif;`,
  },
  colors,
  styles,
  components: {
    Alert,
    Checkbox,
    Button,
    Table,
  },
  semanticTokens,
});

export default theme;
